/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1EodPriceEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_EOD_PRICE_EVENT_ENTITY_NAME = 'ixc.assets.v1.EodPriceEvent';
export const ixcAssetsV1EodPriceEventEntity = new schema.Entity<IxcAssetsV1EodPriceEvent>(IXC_ASSETS_V1_EOD_PRICE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1EodPriceEvent) => `${entity.metadata?.eventId}` });

